"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    id: "success-order",
    class: "w-full 2xl:container mx-auto p-4 flex flex-col gap-8 mt-8"
};
const _hoisted_2 = { class: "text-center uppercase border-b-2 pb-8 border-gray-dark" };
const _hoisted_3 = { class: "text-[30px] font-bold" };
const _hoisted_4 = { class: "flex flex-col md:flex-row items-center justify-center gap-4" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "text-green marso-icon-SHOP-kosr text-[100px] relative" }, null, -1);
const _hoisted_6 = { class: "flex flex-col gap-2" };
const _hoisted_7 = { class: "font-bold text-2xl" };
const _hoisted_8 = { class: "text-lg max-w-sm" };
const _hoisted_9 = {
    key: 0,
    class: "text-lg max-w-sm"
};
const _hoisted_10 = { class: "font-bold" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "text-lg max-w-sm"
};
const _hoisted_13 = { class: "font-bold text-blue" };
const _hoisted_14 = { class: "font-bold text-blue" };
const _hoisted_15 = { class: "flex flex-col md:flex-row gap-4 w-full max-w-xl mx-auto items-stretch justify-center" };
const vue_router_1 = require("vue-router");
const toastStore_1 = require("../../stores/toast/toastStore");
const OrderSummary_vue_1 = __importDefault(require("../orders/OrderSummary.vue"));
const i18n_1 = require("../../common/i18n");
const vue_3 = require("vue");
const ordersStore_1 = require("../../stores/orders/ordersStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SuccessOrder',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const ordersStore = (0, ordersStore_1.useOrdersStore)();
        const order = (0, vue_3.computed)(() => ordersStore.order);
        const getOrder = async () => {
            try {
                await ordersStore.getOrder(router, Number(route.params.id));
                if (!order.value || !order.value.products || !Array.isArray(order.value.products)) {
                    return;
                }
                const products = order.value.products;
                const totalValue = Math.round(products.reduce((total, product) => {
                    return total + product.priceNet * product.quantity;
                }, 0));
                const gtagData = {
                    transaction_id: order.value.id,
                    value: totalValue,
                    currency: order.value.currencyCode,
                    items: products.map((product) => ({
                        item_id: product.id,
                        item_name: product.name,
                        price: product.priceNet,
                        quantity: product.quantity,
                    })),
                };
                gtag("event", "purchase", gtagData);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.onMounted)(async () => {
            await getOrder();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_success", "Order successful!", "success_order")), 1)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    _hoisted_5,
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("thank_you_for_your_order", "Thank you for your order!", "success_order")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("receive_order_email", "You will receive shortly an email about the details of your order.", "success_order")), 1),
                        ((_a = (0, vue_2.unref)(order)) === null || _a === void 0 ? void 0 : _a.axaptaIdList)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("axapta_id", "Your given axapta ID: ", "success_order")) + " ", 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(order).axaptaIdList), 1),
                                (((_b = (0, vue_2.unref)(order)) === null || _b === void 0 ? void 0 : _b.axOrderHead) && (0, vue_2.unref)(order).axOrderHead.length > 0 && ((_c = (0, vue_2.unref)(order).axOrderHead[0]) === null || _c === void 0 ? void 0 : _c.SenderOrderId))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_11, " (" + (0, vue_2.toDisplayString)((0, vue_2.unref)(order).axOrderHead[0].SenderOrderId) + ") ", 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("axapta_id_soon", "Your given axapta ID: ", "success_order")) + " ", 1),
                                (0, vue_2.createElementVNode)("span", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("soon", "SOON", "success_order")), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("you_will_get_the_email", "The order is successful, we will send you an email within an hour with the axapta id. If you do not receive the email please let us know.", "success_order")), 1)
                            ]))
                    ])
                ]),
                (0, vue_2.createVNode)(OrderSummary_vue_1.default, { "my-order": (0, vue_2.unref)(order) }, null, 8, ["my-order"]),
                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                    (0, vue_2.createVNode)(_component_router_link, {
                        to: { name: 'queries_open_orders' },
                        class: "btn btn-rounded btn-primary h-[40px] w-full"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("open_orders", "Open orders", "success_order")), 1)
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_router_link, {
                        to: { name: 'home' },
                        class: "btn btn-rounded btn-primary h-[40px] w-full"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("back_to_shop", "Back to the shop", "success_order")), 1)
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
